import _JSXStyle from "styled-jsx/style";
import { sharedPropTypes, colors } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
export const getInitials = name => {
  const nameParts = name.split(' ');
  let initials = nameParts.shift().charAt(0);
  if (nameParts.length) {
    initials += nameParts.pop().charAt(0);
  }
  return initials;
};
export const TextAvatar = _ref => {
  let {
    name,
    dataTest = 'dhis2-uicore-textavatar',
    extralarge,
    extrasmall,
    large,
    medium,
    small
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    "aria-label": name,
    className: _JSXStyle.dynamic([["1018031843", [colors.grey800, colors.grey050]]]) + " " + "text-avatar"
  }, /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["1018031843", [colors.grey800, colors.grey050]]]) + " " + (cx('text-avatar-initials', {
      extrasmall,
      small,
      medium,
      large,
      extralarge
    }) || "")
  }, getInitials(name)), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1018031843",
    dynamic: [colors.grey800, colors.grey050]
  }, [`.text-avatar.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;overflow:hidden;border-radius:50%;background-color:${colors.grey800}cc;color:${colors.grey050};cursor:pointer;}`, ".text-avatar-initials.__jsx-style-dynamic-selector{font-size:80%;font-weight:500;-webkit-letter-spacing:1px;-moz-letter-spacing:1px;-ms-letter-spacing:1px;letter-spacing:1px;text-align:center;text-transform:uppercase;}", ".text-avatar-initials.extrasmall.__jsx-style-dynamic-selector{font-size:7px;}", ".text-avatar-initials.small.__jsx-style-dynamic-selector{font-size:9px;}", ".text-avatar-initials.medium.__jsx-style-dynamic-selector{font-size:14px;}", ".text-avatar-initials.large.__jsx-style-dynamic-selector{font-size:22px;}", ".text-avatar-initials.extralarge.__jsx-style-dynamic-selector{font-size:32px;}"]));
};
TextAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  dataTest: PropTypes.string,
  extralarge: sharedPropTypes.sizePropType,
  extrasmall: sharedPropTypes.sizePropType,
  large: sharedPropTypes.sizePropType,
  medium: sharedPropTypes.sizePropType,
  small: sharedPropTypes.sizePropType
};